const CloudNationLogo = () => (
  <img
    src="/CloudNationLogo.png"
    alt="CloudNation Logo"
    className="h-8 w-auto"
  />
);

export default CloudNationLogo;
